import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { Agreement } from "@modules/agreements/types";
import { ListAgreementsQueryFilters } from "./types";

export async function getAgreementsService(
  filters?: ListAgreementsQueryFilters
): Promise<Agreement[]> {
  try {

    const params: any = {
      page: filters?.page,
      page_size: filters?.perPage,
      search: filters?.search,
      ids: Array.isArray(filters?.ids) ? filters.ids.join(",") : undefined,
    }
    if (typeof filters?.active !== 'undefined') {
      params.active = filters.active
    }
    if (filters?.integration_id) {
      params.integration_id = filters.integration_id
    }
    if (typeof filters?.has_integration !== 'undefined') {
      params.has_integration = filters.has_integration
    }
    if (typeof filters?.product_module !== 'undefined') {
      params.product_module = filters.product_module
    }
    if (typeof filters?.only_with_products !== 'undefined') {
      params.only_with_products = filters.only_with_products
    }

    const { data } = await api.get<ApiResponse<Agreement>>(
      `v1/agreement_admin/`,
      {
        params: params
      }
    );
    return data.results;
  } catch (error) {
    console.error("Error fetching agreements:", error);
    throw error;
  }
}

/** Retorna apenas convênios que possuem integração (integration_id preenchido). */
export async function getAgreementsWithIntegrationService(
  filters?: ListAgreementsQueryFilters
): Promise<Agreement[]> {
  return getAgreementsService({
    ...filters,
    perPage: filters?.perPage ?? 200,
    has_integration: true,
  });
}

export async function getAgreementsByIdService(
  agreementId: string
): Promise<Agreement> {
  try {
    const { data } = await api.get<Agreement>(
      `v1/agreement_admin/${agreementId}/`
    );
    return data;
  } catch (error) {
    console.error("Error fetching agreements:", error);
    throw error;
  }
}

export async function getBookSectorsService(): Promise<any[]> {
  try {
    const { data } = await api.get<ApiResponse<any>>(`v2/bookstore/book_sector_admin/`);

    return data.results;
  } catch (error) {
    console.error("Error fetching book sectors:", error);
    throw error;
  }
}
